<ion-header>
  <ion-toolbar>
    <ion-title>Add exercise</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeView.emit()"><ion-icon name="close-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<app-create-exercise [loading]="loading" (emitCreatedExercse)="addExercise($event)"></app-create-exercise>
